import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevanseaterurbaniaonrentinpune() {



  const cardData =
  {
    keyword: '17 Seater Force Urbania on Rent in Pune',
    heading: 'Amruta Travels: 17 Seater Force Urbania on Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides 17 Seater Force Urbania on Rent in Pune, offering a premium blend of comfort, luxury, and convenience for group travel. Ideal for corporate trips, family vacations, weddings, and airport transfers, our 17-seater Force Urbania vans feature spacious interiors, plush push-back seats, advanced air conditioning, and smooth suspension for a relaxing travel experience. Each vehicle is driven by a professional chauffeur who ensures punctuality, safety, and a hassle-free journey from start to finish. Whether you’re traveling within Pune or heading to destinations like Mumbai, Mahabaleshwar, or Shirdi, Amruta Travels’ 17 Seater Force Urbania Rental in Pune delivers unmatched comfort, reliability, and style for every occasion.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s legendary fort and the grand seat of the Peshwas, built in 1732. Once a magnificent palace of the Maratha Empire, it is now a historic monument showcasing royal architecture and tales of valor. The light and sound show held every evening beautifully narrates its glorious past. Shaniwar Wada remains the proud symbol of Pune’s cultural and political legacy."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace is a splendid example of Indo-Islamic architecture built in 1892 by Sultan Muhammed Shah Aga Khan III. It played a crucial role during India’s freedom movement as the place where Mahatma Gandhi and Kasturba Gandhi were imprisoned. The museum inside preserves rare photographs, letters, and personal belongings of Gandhi. This serene palace is Pune’s eternal monument of peace and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the Sahyadri hills, Sinhagad Fort offers spectacular views and echoes stories of Maratha bravery. It was here that Tanaji Malusare fought valiantly under the command of Chhatrapati Shivaji Maharaj. The fort’s rugged trails, historical ruins, and traditional Maharashtrian food make it a favorite trekking spot. Sinhagad stands as Pune’s enduring symbol of courage and pride."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most celebrated spiritual landmark, dedicated to Lord Ganesha. Its gold-adorned idol radiates divine beauty and attracts lakhs of devotees every year. During Ganesh Chaturthi, the temple transforms into a dazzling spectacle of devotion and festivity. It represents Pune’s heart of faith, culture, and community harmony."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers one of the most breathtaking views of Pune and houses an ancient temple dedicated to Lord Shiva and Goddess Parvati. Built by the Peshwas, it holds immense historical and spiritual value. The 108-step climb rewards visitors with peace and panoramic vistas. Parvati Hill blends devotion, history, and natural beauty into one soulful experience."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved from basalt in the 8th century, is a marvel of rock-cut architecture dedicated to Lord Shiva. Its circular Nandi pavilion and monolithic pillars reflect ancient craftsmanship. Located amidst the city’s chaos, it offers a tranquil retreat for meditation. Pataleshwar remains Pune’s hidden spiritual gem from a bygone era."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a fascinating collection of over 20,000 artifacts from across India. Curated by Dr. D.G. Kelkar, the exhibits include musical instruments, sculptures, and traditional art. Each artifact tells a story of India’s cultural richness and everyday life. It’s one of Pune’s most educational and artistic treasures."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Set in the lush Koregaon Park area, Osho International Meditation Resort is a world-renowned wellness retreat. It offers meditation, yoga, and holistic programs to visitors from around the globe. The serene gardens, modern architecture, and peaceful atmosphere make it a spiritual haven. Osho Ashram represents Pune’s cosmopolitan identity and quest for inner peace."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is Pune’s favorite weekend destination, offering beautiful lakeside views and cool breezes. Built across the Mutha River, it is surrounded by hills and small food stalls serving local delicacies. The sunsets here are mesmerizing, making it a perfect spot for family picnics and photography. Khadakwasla captures the tranquil side of Pune’s natural beauty."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s Korakuen Garden, the Pune Okayama Friendship Garden is a masterpiece of landscaping and serenity. Its bridges, flowing streams, and manicured lawns reflect Japanese aesthetics and harmony. Named after the Marathi writer Pu La Deshpande, it’s a favorite spot for families and nature lovers. The garden symbolizes Pune’s bond of friendship and global culture."
  }
],



       "services": [
    {
      "name": "17 Seater Force Urbania on Rent in Pune",
      "description": "17 Seater Force Urbania on Rent in Pune offers an unmatched blend of space, luxury, and safety for group travelers heading to destinations across Maharashtra. Designed for family tours, corporate outings, and leisure journeys, this vehicle features spacious push-back seats, air conditioning, and ample legroom for all passengers. Each Urbania undergoes regular maintenance, ensuring reliable performance on highways and hilly terrains alike. Professional drivers trained in long-route driving guarantee a smooth and safe experience from pickup to drop-off. Whether it’s a weekend getaway to Lonavala, a wedding event, or an airport transfer, this service delivers premium comfort with punctuality and professionalism. With 24/7 booking support and flexible travel packages, it’s the ideal solution for hassle-free group travel from Pune."
    },
    {
      "name": "Force Urbania 17 Seater Hire Pune",
      "description": "Force Urbania 17 Seater Hire Pune is perfect for large families, office teams, and tourists seeking a luxurious and practical travel option. The 17-seater model is designed with ergonomic seating, climate control, and wide windows that enhance comfort and visibility during long drives. The service emphasizes punctuality, hygiene, and customer satisfaction, offering professional chauffeurs who understand Pune’s routes thoroughly. Whether for a business trip, school tour, or outstation vacation, passengers enjoy a relaxing journey with complete peace of mind. The service also includes convenient pick-up and drop-off scheduling, making it suitable for both planned and spontaneous travel. With flexible rental durations and transparent pricing, this Force Urbania hire ensures maximum convenience for every occasion."
    },
    {
      "name": "17 Seater Urbania Booking Pune",
      "description": "17 Seater Urbania Booking Pune offers an easy, fast, and transparent process for booking premium mini buses across the city. Customers can reserve online or via phone, selecting the exact travel date, route, and amenities they prefer. The vehicles are ideal for corporate travel, school excursions, religious tours, and outstation holidays. Each Urbania features advanced safety systems, clean interiors, and cushioned seating for extended comfort. With real-time availability and secure payment options, travelers can plan their journeys effortlessly. A dedicated customer support team ensures that booking modifications and travel changes are handled quickly. Whether you’re planning a multi-day tour or a one-day event, 17 Seater Urbania Booking Pune guarantees convenience and reliability at every step."
    },
    {
      "name": "AC 17 Seater Urbania Pune",
      "description": "AC 17 Seater Urbania Pune provides an exceptionally comfortable and cool travel experience ideal for Pune’s warm climate and long road trips. The air-conditioned cabins are designed for superior ventilation, keeping passengers refreshed even during extended drives. Equipped with plush push-back seats, LED lighting, and music systems, the journey becomes both relaxing and entertaining. This service is particularly popular among corporate teams, wedding guests, and family groups who value comfort and punctuality. Every vehicle is thoroughly sanitized and maintained to meet the highest safety standards. Professional chauffeurs ensure smooth navigation through city traffic and ghat sections. AC 17 Seater Urbania Pune transforms every group trip into a luxurious road experience."
    },
    {
      "name": "Non AC 17 Seater Urbania Pune",
      "description": "Non AC 17 Seater Urbania Pune is a practical and cost-effective solution for short-distance and city group travel. It provides all the reliability and spacious comfort of the Urbania series without the additional cost of air conditioning. The vehicles are well-kept, featuring cushioned seats, wide legroom, and ample luggage capacity, ensuring comfort throughout your journey. This service is ideal for budget-friendly travel such as school picnics, community trips, and local sightseeing tours. The focus remains on punctuality, safety, and cleanliness. With transparent pricing and courteous drivers, passengers can expect a convenient travel experience without compromising on quality or comfort."
    },
    {
      "name": "Luxury 17 Seater Urbania Pune",
      "description": "Luxury 17 Seater Urbania Pune offers a high-end travel experience for those who prefer comfort, elegance, and class. The interiors are crafted with plush upholstery, soft lighting, and entertainment systems to ensure passengers enjoy every moment of their journey. Ideal for VIPs, corporate executives, or wedding guests, this service guarantees exclusivity and sophistication on the road. Air suspension, sound insulation, and temperature control add to the smooth ride quality. Every vehicle is maintained to premium standards, ensuring a luxurious travel experience. From Pune city tours to outstation destinations like Mahabaleshwar or Nashik, Luxury Urbania promises comfort beyond expectations."
    },
    {
      "name": "Force Urbania Rental Pune",
      "description": "Force Urbania Rental Pune provides reliable rental options for personal and professional travel needs. Featuring a fleet of clean, modern, and fully serviced Urbania vans, it ensures a smooth travel experience across all routes. The vehicles are available in multiple configurations, including AC and non-AC options, with seating for 12–17 passengers. The rental service supports flexible hourly, daily, and outstation packages. Experienced chauffeurs and 24/7 support guarantee peace of mind for every client. Whether for corporate events, school tours, or pilgrimages, Force Urbania Rental Pune delivers quality transportation tailored to your schedule and comfort preferences."
    },
    {
      "name": "17 Seater Urbania for Corporate Pune",
      "description": "17 Seater Urbania for Corporate Pune caters to professional groups and companies seeking dependable transport for meetings, events, and business trips. With elegant interiors, Wi-Fi options, and air conditioning, it creates a productive environment on the move. Each Urbania is maintained for comfort and hygiene, ensuring your team travels efficiently between offices or off-site locations. The drivers are punctual, courteous, and well-acquainted with Pune’s business hubs like Hinjewadi, Kharadi, and Baner. Companies can opt for daily, weekly, or monthly hire plans. This service provides both comfort and a professional impression for corporate mobility."
    },
    {
      "name": "17 Seater Urbania for Wedding Pune",
      "description": "17 Seater Urbania for Wedding Pune adds a touch of luxury and convenience to your special day. The vehicles can be beautifully decorated to match wedding themes and are perfect for guest transfers, family travel, or event logistics. Plush interiors, climate control, and comfortable seating ensure everyone enjoys a relaxing journey between venues. Punctual drivers and clean vehicles guarantee smooth coordination for every wedding function. This service ensures that every guest arrives in comfort and style, reflecting the grandeur of your celebration. Ideal for pre-wedding functions, receptions, and destination weddings around Pune."
    },
    {
      "name": "17 Seater Urbania for Outstation Pune",
      "description": "17 Seater Urbania for Outstation Pune is perfect for long-distance travel to destinations like Goa, Shirdi, or Mahabaleshwar. With soft suspension, ample legroom, and luggage space, these vehicles make extended journeys extremely comfortable. Safety is ensured with experienced drivers who are skilled in intercity driving. The service supports flexible pickup timings, multiple stops, and customizable routes. Whether you’re planning a weekend trip or a family pilgrimage, this Urbania provides reliability, comfort, and peace of mind throughout the journey. Travel beyond Pune with confidence and convenience."
    },
    {
      "name": "Force Urbania Hire in Baner",
      "description": "Force Urbania Hire in Baner serves residents and businesses in Baner with premium travel options. Whether for corporate teams, tourists, or families, these 17-seater vehicles deliver exceptional comfort and punctuality. The service offers both AC and luxury variants with trained drivers who are familiar with city and outstation routes. Customers benefit from flexible rental packages and instant booking confirmations. Clean interiors, soft suspension, and efficient air conditioning ensure every journey begins and ends comfortably. With round-the-clock availability, it’s Baner’s most dependable Urbania rental service."
    },
    {
      "name": "Force Urbania Hire in Hinjewadi",
      "description": "Force Urbania Hire in Hinjewadi is tailored for the IT and corporate community in Pune’s busiest tech hub. Offering professional and punctual group transport, these vehicles are ideal for daily employee transfers, corporate outings, and client visits. The fleet features spacious seating, air conditioning, and entertainment systems for maximum comfort. Drivers are trained to handle peak-hour traffic efficiently, ensuring timely arrivals. This service combines luxury and reliability for corporate mobility. For teams traveling to business events or off-site locations, Force Urbania Hire in Hinjewadi ensures a stress-free experience."
    },
    {
      "name": "Force Urbania Hire in Hadapsar",
      "description": "Force Urbania Hire in Hadapsar delivers convenient and luxurious group transport services for families, corporate travelers, and tourists. Each Urbania is equipped with modern amenities such as reclining seats, climate control, and music systems. Drivers are courteous and familiar with Hadapsar’s routes, ensuring punctual service every time. Whether for business travel, weddings, or outstation tours, this service offers customized packages to suit your travel needs. Regular vehicle maintenance ensures safety and comfort, making every trip reliable and pleasant. With affordable pricing, it’s the top choice for Hadapsar-based travelers."
    },
    {
      "name": "Affordable 17 Seater Urbania Pune",
      "description": "Affordable 17 Seater Urbania Pune is designed for budget-conscious travelers who don’t want to compromise on comfort. The service provides well-maintained vehicles with spacious seating, clean interiors, and reliable drivers. It’s ideal for group travel, school trips, and weekend tours around Maharashtra. The pricing is transparent and competitive, with no hidden charges. Passengers enjoy a safe and punctual journey every time. With 24x7 availability, easy online booking, and flexible rental durations, it’s the perfect choice for economical yet premium group transportation in Pune."
    },
    {
      "name": "Force Urbania Hire near Me Pune",
      "description": "Force Urbania Hire near Me Pune ensures immediate availability of luxury mini-bus rentals across Pune. Customers can quickly locate and book vehicles for family events, business trips, or leisure outings. The service emphasizes fast response times, experienced drivers, and flexible schedules. Every vehicle is equipped with comfort features, clean interiors, and reliable performance. With pickup options available in multiple Pune neighborhoods, travelers can enjoy seamless transport wherever they are. It’s the most convenient way to hire an Urbania without travel delays or booking hassles."
    },
    {
      "name": "17 Seater Urbania Van Pune",
      "description": "17 Seater Urbania Van Pune combines functionality with elegance for group travelers who prioritize comfort. Each van is equipped with plush seating, air conditioning, and advanced safety systems. The service is suitable for large family trips, corporate tours, and tourism circuits across Maharashtra. Professional drivers ensure every journey is safe and timely. The fleet is kept in top condition with regular servicing and hygiene checks. Travelers enjoy ample luggage space, wide windows for scenic views, and smooth driving through any terrain. It’s the ultimate solution for reliable urban and intercity travel."
    },
    {
      "name": "Force Urbania Pune City",
      "description": "Force Urbania Pune City service is dedicated to local travel within Pune, ensuring comfortable and stylish mobility for city tours, business meetings, and daily transfers. The 17-seater vans are ideal for large groups exploring attractions like Shaniwar Wada, Aga Khan Palace, or Khadakwasla. With flexible hourly rentals, clients can plan multiple stops easily. Vehicles are driven by courteous chauffeurs who know the city’s routes and shortcuts perfectly. This service ensures safe, punctual, and elegant transportation for city-based travelers and event organizers."
    },
    {
      "name": "Premium Urbania Pune",
      "description": "Premium Urbania Pune is tailored for customers who desire first-class travel experiences. These luxury vans come with elegant interiors, leather seats, ambient lighting, and advanced air-conditioning systems. Each trip is handled by a professional driver who prioritizes comfort, safety, and discretion. The service caters to corporate executives, VIP guests, and families seeking premium road travel. Vehicles are sanitized before every journey, ensuring cleanliness and hygiene. Flexible booking options, dedicated customer service, and attention to detail make Premium Urbania Pune the hallmark of luxury travel in the city."
    }
  ],
  "tableData": [
    ["17 Seater Force Urbania on Rent in Pune", "Force Urbania 17 Seater Hire Pune"],
    ["17 Seater Urbania Booking Pune", "AC 17 Seater Urbania Pune"],
    ["Non AC 17 Seater Urbania Pune", "Luxury 17 Seater Urbania Pune"],
    ["Force Urbania Rental Pune", "17 Seater Urbania for Corporate Pune"],
    ["17 Seater Urbania for Wedding Pune", "17 Seater Urbania for Outstation Pune"],
    ["Force Urbania Hire in Baner", "Force Urbania Hire in Hinjewadi"],
    ["Force Urbania Hire in Hadapsar", "Affordable 17 Seater Urbania Pune"],
    ["Force Urbania Hire near Me Pune", "17 Seater Urbania Van Pune"],
    ["Force Urbania Pune City", "Premium Urbania Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "17 Seater Force Urbania on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers spacious and reliable 17 seater Force Urbania rental services in Pune, ideal for comfortable group travel."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our 17 seater Force Urbania vans are regularly serviced and thoroughly cleaned to ensure your safety and comfort."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from upfront rental rates with no hidden charges, inclusive of all taxes and fees."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental options tailored to your specific travel needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous drivers provide safe, punctual, and pleasant journeys every time."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, inquiries, and travel arrangements."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your 17 seater Force Urbania easily online or via phone, with prompt vehicle delivery anywhere in Pune."
  },
  {
    "WhyChooseheading": "Customer Satisfaction Commitment",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is committed to delivering reliable, comfortable, and hassle-free group travel experiences."
  }
]










  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer 17 seater Force Urbania on rent in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides 17 seater Force Urbania vehicles on rent in Pune, perfect for medium-sized group travel and events.',
  },
  {
    question: 'How can I book a 17 seater Force Urbania for hire in Pune with Amruta Travels?',
    answer: 'Booking is easy through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the 17 seater Force Urbania vehicles in Pune?',
    answer: 'Our 17 seater Force Urbania vehicles are equipped with comfortable seating, air conditioning, and essential safety features for a pleasant ride.',
  },
  {
    question: 'Are the drivers trained and experienced for 17 seater Force Urbania hires in Pune?',
    answer: 'Absolutely. Our drivers are professional, courteous, and experienced in driving 17 seater Force Urbania vehicles safely.',
  },
  {
    question: 'Can 17 seater Force Urbania vehicles be hired for weddings, corporate events, and tours in Pune?',
    answer: 'Yes, these vehicles are ideal for weddings, corporate outings, airport transfers, and sightseeing tours in Pune.',
  },
  {
    question: 'Is the 17 seater Force Urbania hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for 17 seater Force Urbania hire services to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for 17 seater Force Urbania hires?',
    answer: 'All vehicles are thoroughly sanitized before every trip, and drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for 17 seater Force Urbania hire in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the 17 seater Force Urbania hire period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you at any time during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Deshpande',
    feedback: 'The 17 seater Force Urbania from Amruta Travels Pune was spacious and comfortable. The driver was punctual and very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Great experience with Amruta Travels. The 17 seater Force Urbania was perfect for our corporate event in Pune.',
    rating: 5,
  },
];











































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Force Urbania on Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/28.jpg",
  "description": "Rent a 17 Seater Force Urbania in Pune with Amruta Travels Pvt. Ltd. Comfortable AC and Non-AC Urbania options for corporate trips, weddings, and outstation travel. Affordable and premium Urbania hire services.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "13200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/17-seater-force-urbania-on-rent-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>17 Seater Force Urbania on Rent in Pune | Affordable & Premium Urbania Hire | Amruta Travels</title>
  <meta
    name="description"
    content="Rent a 17 Seater Force Urbania in Pune with Amruta Travels Pvt. Ltd. Comfortable AC and Non-AC Urbania options for corporate trips, weddings, and outstation travel. Affordable and premium Urbania hire services."
  />
  <meta
    name="keywords"
    content="17 Seater Force Urbania on Rent in Pune, Force Urbania 17 Seater Hire Pune, 17 Seater Urbania Booking Pune, AC 17 Seater Urbania Pune, Non AC 17 Seater Urbania Pune, Luxury 17 Seater Urbania Pune, Force Urbania Rental Pune, 17 Seater Urbania for Corporate Pune, 17 Seater Urbania for Wedding Pune, 17 Seater Urbania for Outstation Pune, Force Urbania Hire in Baner, Force Urbania Hire in Hinjewadi, Force Urbania Hire in Hadapsar, Affordable 17 Seater Urbania Pune, Force Urbania Hire near Me Pune, 17 Seater Urbania Van Pune, Force Urbania Pune City, Premium Urbania Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesevanseaterurbaniaonrentinpune;